import type { Field } from '@/modules/Project/Fields/types'
import { useFieldDeleteFile } from '@/modules/Project/useFieldDeleteFile'
import { invariant } from '@/shared/utils/typeAssertions'
import { createSharedComposable } from '@vueuse/core'
import { ref } from 'vue'

export const useFieldDeleteFileConfirmation = createSharedComposable(() => {
  const fileDeletionInfo = ref<{
    field: Field<'file' | 'data'>
    parentEntityId: string | null
  } | null>(null)

  const deleteFieldFile = async () => {
    const { deleteFile } = useFieldDeleteFile()
    invariant(fileDeletionInfo.value)
    await deleteFile(fileDeletionInfo.value.field, fileDeletionInfo.value.parentEntityId)
    fileDeletionInfo.value = null
  }

  const setFileDeletionInfo = (field: Field<'file' | 'data'>, parentEntityId: string | null) => {
    fileDeletionInfo.value = { field, parentEntityId }
  }

  const clearFileDeletionInfo = () => {
    fileDeletionInfo.value = null
  }

  return {
    fileDeletionInfo,
    setFileDeletionInfo,
    clearFileDeletionInfo,
    deleteFieldFile,
  }
})
